import React from "react";
import { Col } from "antd";

import CustomRow from "../../../shared/costum-row/costum-row";
import CustomButton from "../../../shared/custom-button/custom-button";
import CustomInput from "../../../shared/custom-input/custom-input";
import CustomTextArea from "../../../shared/custom-text-area/custom-text-area";
import ContactForm from "../../../components/contact-form/contact-form";
import Headline from "../../../components/headline/headline";
import TeaserTeam from "../../../components/teaser-team/teaser-team";
import TeaserHome from "../../../components/teaster-home/teaser-home";
import BlogTeaser from "../../../components/blog-teaser/blog-teaser";
import CaseCard from "../../../components/case-card/case-card";
import AboutCard from "../../../components/about-card/about-card";
import ProfileCard from "../../../components/profile-card/profile-card";
import BlogCard from "../../../components/blog-card/blog-card";
import TestimonialSection from "../../../components/testimonial-section/testimonial-section";
import ServiceProcess from "../../../components/service-process/service-process";
import Service from "../../../components/service/service";
import Usp from "../../../components/usp/usp";
import Usps from "../../../components/usps/usps";
import ContactUs from "../../../components/contact-us/contact-us";

import { BUTTON_VARIANTS } from "../../../constants/styles";
import {
  HEADLINE_ORIENTATION,
  SERVICE_PROCESS_DIRECTION,
} from "../../../constants/props";
import Testimonial from "../../../components/testimonial/testimonial";
import { BLOG_CONTENT } from "../../../constants/content/pages/blog";
import { CASES_CONTENT } from "../../../constants/content/pages/cases";

const ComponentShowcase = () => {
  return (
    <div>
      {" "}
      <CustomRow gutter={[0, 40]} className="pl-xl pr-xl">
        <Col span={24}>
          <CustomButton btnVariant={BUTTON_VARIANTS.PRIMARY}>
            Button
          </CustomButton>
        </Col>
        <Col span={24}>
          <CustomButton btnVariant={BUTTON_VARIANTS.TEXT}>Button</CustomButton>
        </Col>
        <Col span={24}>
          <CustomButton btnVariant={BUTTON_VARIANTS.FORM}>Button</CustomButton>
        </Col>
        <Col span={24}>
          <CustomButton btnVariant={BUTTON_VARIANTS.SECONDARY}>
            Button
          </CustomButton>
        </Col>

        <Col
          span={24}
          style={{ backgroundColor: "#777777", borderRadius: "10px" }}
          className="pt-xl pb-xl pl-xl pr-xl"
        >
          <CustomInput
            placeholder="Type Your Name Here"
            value={"Type Your Name Here"}
            className="CustomInput-search"
          />
        </Col>

        <Col
          span={24}
          style={{ backgroundColor: "#777777", borderRadius: "10px" }}
          className="pt-xl pb-xl pl-xl pr-xl"
        >
          <CustomTextArea
            placeholder="Type Your Name Here"
            value={"Type Your Name Here"}
            className="CustomInput-search"
            rows={6}
          />
        </Col>

        <Col
          span={24}
          style={{ backgroundColor: "#777777", borderRadius: "10px" }}
          className="pt-xl pb-xl pl-xl pr-xl"
        >
          <ContactForm />
        </Col>

        <Col span={24}>
          <Headline
            title="Services"
            subtitle="Our comprehensive range of technology solutions designed to help businesses thrive in the digital era."
            orientation={HEADLINE_ORIENTATION.TOP}
          />
        </Col>

        <Col span={24}>
          <Headline
            title="Services"
            subtitle="Our comprehensive range of technology solutions designed to help businesses thrive in the digital era."
            orientation={HEADLINE_ORIENTATION.BOTTOM}
          />
        </Col>

        <Col span={24}>
          <TeaserTeam />
        </Col>

        <Col span={24}>
          <TeaserHome />
        </Col>

        <Col span={24}>
          <BlogTeaser blogPost={BLOG_CONTENT.blogPosts[0]} />
        </Col>

        <Col span={24}>
          <CaseCard caseProject={CASES_CONTENT.caseProjects[0]} />
        </Col>

        <Col span={24}>
          <AboutCard />
        </Col>

        <Col span={24}>
          <ProfileCard />
        </Col>

        <Col span={24}>
          <BlogCard />
        </Col>

        <Col span={24}>
          <Testimonial />
        </Col>

        <Col span={24}>
          <ServiceProcess
            number={1}
            title="Discovery & Planning"
            description="We start by understanding your vision, goals, and requirements through collaborative workshops and detailed analysis."
            direction={SERVICE_PROCESS_DIRECTION.LEFT}
          />
        </Col>

        <Col span={24}>
          <ServiceProcess
            number={2}
            title="Design & Prototyping"
            description="Our design phase transforms concepts into tangible prototypes, focusing on user experience and interface design."
            direction={SERVICE_PROCESS_DIRECTION.RIGHT}
          />
        </Col>
        <Col span={24}>
          <ServiceProcess
            number={3}
            title="Development"
            description="Using modern practices and technologies, our team brings your solution to life with iterative development cycles."
            direction={SERVICE_PROCESS_DIRECTION.LEFT}
          />
        </Col>
        <Col span={24}>
          <ServiceProcess
            number={4}
            title="Testing & QA"
            description="Our rigorous testing methodology ensures your solution is robust, secure, and performs optimally across all platforms."
            direction={SERVICE_PROCESS_DIRECTION.RIGHT}
          />
        </Col>
        <Col span={24}>
          <ServiceProcess
            number={5}
            title="Deployment & Support"
            description="We ensure smooth deployment and provide comprehensive support after launch as your business evolves and grows."
            direction={SERVICE_PROCESS_DIRECTION.LEFT}
          />
        </Col>

        <Col span={24}>
          <Service
            title="In-House Products"
            description="We don't just build for clients—we create our own innovative solutions
          to solve real-world problems, bringing cutting-edge tech to market. "
          />
        </Col>

        <Col span={24}>
          <Usp />
        </Col>

        <Col span={24}>
          <h3>USPs Row Layout (Home Page)</h3>
          <Usps layout="row" />
        </Col>

        <Col span={24}>
          <h3>USPs Grid Layout (About Us Page)</h3>
          <Usps layout="grid" />
        </Col>

        <Col span={24}>
          <ContactUs />
        </Col>
      </CustomRow>
    </div>
  );
};

export default ComponentShowcase;
